import './polyfill';
import Vue from 'vue';
import BootstrapVue from 'bootstrap-vue';
import Toast from 'vue-notification';
import App from './App.vue';
import router from './router';
import store from './store';
import Startup from './common/Startup';
import VueTimers from 'vue-plugin-timers';
import { FormatHelper } from './common/helpers';
import vuetify from './plugins/vuetify';

Vue.use(BootstrapVue);
Vue.use(Toast);
Vue.use(VueTimers);
Vue.config.productionTip = false;

Vue.filter('formatDate', (date: Date, format: string) => {
  return date ? FormatHelper.formatDate(date.toString(), format) : '';
});

Startup.configureApp().then((factory) => {
  Vue.prototype.$factory = factory;
  const authService = factory.createAuthService();

  authService.checkAuthenticationSession().then(() => {
    new Vue({
      vuetify,
      router,
      store,
      render: (h) => h(App),
    }).$mount('#app');
  });

}).catch((error) => {
  // tslint:disable-next-line:no-console
  console.log(error);
});
